import type { ModuleDefinition } from '../../../../app/moduleRegistry';

/** CMS İçerik: En Ucuz Rotalar (CheapestDestination) — Master-GSA-only, gated behind
 *  `HasCmsB2C`. No longer a standalone routed page: `CheapestDestinationListPage` now
 *  requires a `siteId` prop and is rendered directly as a tab inside `SiteDetailPage` (see
 *  ../../site/site/pages/SiteDetailPage.tsx), so this sub-module contributes no route/menu
 *  item of its own — kept only so the sibling `cms/content` aggregator's import shape stays
 *  uniform. */
export const cheapestDestinationModule: ModuleDefinition = {
  routes: [],
  menuItems: [],
};
